import { ISignersForm } from '../interfaces/ISignersForm';
import { ISigners } from '../../../APIPackage/KnmModule/interfaces/ISigners';

export const convertSignersFormToData = (values: ISignersForm[] | undefined): ISigners[] | null => {
  if (!values) {
    return null;
  }

  return values.map(signer => {
    const resultSigner: ISigners = {
      guid: signer.guid || signer.listId || null,
      fioSigner: (typeof signer.fioSigner === 'string' ? signer.fioSigner : signer.fioSigner?.value) || null,
      titleSigner: signer.titleSigner ? signer.titleSigner.value : null,
      signatureDateTime: signer.signatureDateTime || null,
      existedAtSigning: signer.existedAtSigning || null,
      systemSignature: signer.systemSignature
        ? {
            systemSignatureTitle: signer.systemSignature.systemSignatureTitle || null,
            systemSignatureMnemonic: signer.systemSignature.systemSignatureMnemonic || null,
          }
        : null,
    };

    return resultSigner;
  });
};
